import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useCreateUserContactStatuses } from '../../../../sic-lib/api/hooks/useUserContactStatuses';
import { buildCreateContactStatus } from '../../../../sic-lib/types/ContactStats';
import EditButtonGroup from '../../../Shared/FormControls/Buttons/EditButtonGroup';

interface Props {
    onToggleHandler: () => void;
}

export default function ContactStatusCreate({ onToggleHandler }: Props) {
    const { mutate: createUserContactStatus, isLoading: isCreateLoading } =
        useCreateUserContactStatuses();

    const [status, setStatus] = React.useState<string>('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStatus(event.target.value);
    };

    const handleSave = async () => {
        const newStatus = buildCreateContactStatus({
            status: status,
        });

        createUserContactStatus(newStatus);

        onToggleHandler();
    };

    return (
        <ClickAwayListener onClickAway={onToggleHandler}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item direction="column">
                    <Grid item xs="auto">
                        <TextField
                            id="text_field_label"
                            label="Status"
                            name="Status"
                            value={status}
                            onChange={handleChange}
                            autoFocus
                            required
                        />
                    </Grid>
                </Grid>
                <Grid item xs="auto">
                    <EditButtonGroup
                        onSave={handleSave}
                        onCancel={onToggleHandler}
                        allowDelete={false}
                        size="small"
                    />
                </Grid>
            </Grid>
        </ClickAwayListener>
    );
}
